import {Box, Grid, Stack, styled, Typography} from '@mui/material';
import {blue, grey} from 'styles/color';

const SmallBlogItem = ({
  img_url,
  title,
  description,
  publish_date,
  ...props
}) => {
  return (
    <Grid container sx={{height: '100%', cursor: 'pointer'}} {...props}>
      <Grid item xs={6} sx={{overflow: 'hidden'}}>
        <StyledImg src={img_url} alt="" />
      </Grid>

      <Grid item xs={6}>
        <StackWithBg justifyContent="center" spacing={1}>
          <TitleTypo>{title}</TitleTypo>
          <DescriptionTypo>{description}</DescriptionTypo>
          <PublishDateTypo sx={{paddingTop: 1}} color="grey.450">
            {publish_date}
          </PublishDateTypo>
        </StackWithBg>
      </Grid>
    </Grid>
  );
};

const TitleTypo = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(2.75),
  lineHeight: theme.spacing(3.25),
  color: blue[800],
  fontFamily: ['Noto Sans', 'sans-serif'].join(', '),
}));

const DescriptionTypo = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(1.75),
  lineHeight: theme.spacing(2),
  color: grey[450],
  fontFamily: ['Noto Sans', 'sans-serif'].join(', '),
}));

const PublishDateTypo = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(1.5),
  lineHeight: theme.spacing(1.75),
  color: grey[450],
  fontFamily: ['Noto Sans', 'sans-serif'].join(', '),
}));

const StackWithBg = styled(Stack)(({theme}) => ({
  background: blue[100],
  paddingRight: theme.spacing(5.5),
  paddingLeft: theme.spacing(5.5),
  height: '100%',
  borderTopRightRadius: '10px',
  borderBottomRightRadius: '10px',
}));

const StyledImg = styled('img')(({theme}) => ({
  width: '100%',
  height: '100%',
  borderTopLeftRadius: '10px',
  borderBottomLeftRadius: '10px',
}));

export {SmallBlogItem};
